import { render, staticRenderFns } from "./basePlatform.vue?vue&type=template&id=ff427758&scoped=true&"
import script from "./basePlatform.vue?vue&type=script&lang=ts&"
export * from "./basePlatform.vue?vue&type=script&lang=ts&"
import style0 from "./basePlatform.vue?vue&type=style&index=0&id=ff427758&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff427758",
  null
  
)

export default component.exports